import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    boxSizing: 'border-box',
    borderRadius: idsTokens.avatar.default.radius,
    ':not(:has(img, svg))': {
      flexWrap: 'wrap',
    },
    '&:focus-visible': {
      outlineColor: idsTokens.functional.color.border.focus,
      outlineStyle: 'solid',
      outlineWidth: idsTokens.functional.borderWidth.focus.default,
      boxShadow: 'none',
    },
  },
  colorDefault: {
    color: idsTokens.avatar.default.color.content,
    fontWeight: idsTokens.typography.font.weight.bold,
  },
  img: {
    width: 60,
    height: 60,
  },
});
